<div class="lead-page">
  <div class="lead-shell">
    <div class="lead-header">
      <div class="lead-title">
        <h2>{{ isEdit ? 'Edit Lead' : 'Create Lead' }}</h2>
        <p>Capture ANPR sales requirements without forcing assignment.</p>
      </div>
      <div class="lead-actions">
        <button class="lead-btn-muted" (click)="router.navigate(['lead-management/leads'])">Back to Leads</button>
      </div>
    </div>

    <div class="lead-section">
      <h4>Basic Info</h4>
      <div class="lead-form-grid">
        <div class="lead-form-field">
          <label>Customer Name *</label>
          <input [(ngModel)]="model.customer_name" />
        </div>
        <div class="lead-form-field">
          <label>Contact Person</label>
          <input [(ngModel)]="model.contact_person" />
        </div>
        <div class="lead-form-field">
          <label>Phone Number *</label>
          <input [(ngModel)]="model.phone_number" />
        </div>
        <div class="lead-form-field">
          <label>Email</label>
          <input [(ngModel)]="model.email" />
        </div>
        <div class="lead-form-field">
          <label>WhatsApp Number</label>
          <input [(ngModel)]="model.whatsapp_number" />
        </div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Business Info</h4>
      <div class="lead-form-grid">
        <div class="lead-form-field">
          <label>Company Type</label>
          <select [(ngModel)]="model.company_type">
            <option value="">Select</option>
            <option *ngFor="let companyType of companyTypes" [value]="companyType[0]">{{ companyType[1] }}</option>
          </select>
        </div>
        <div class="lead-form-field">
          <label>City</label>
          <input [(ngModel)]="model.city" />
        </div>
        <div class="lead-form-field">
          <label>State</label>
          <input [(ngModel)]="model.state" />
        </div>
        <div class="lead-form-field" style="grid-column: 1 / -1;">
          <label>Address</label>
          <textarea [(ngModel)]="model.address"></textarea>
        </div>
      </div>
    </div>

    <div class="lead-section">
      <h4>ANPR Requirement Info</h4>
      <div class="lead-form-grid">
        <div class="lead-form-field">
          <label>Number of Entry Gates</label>
          <input type="number" [(ngModel)]="model.entry_gates" />
        </div>
        <div class="lead-form-field">
          <label>Number of Exit Gates</label>
          <input type="number" [(ngModel)]="model.exit_gates" />
        </div>
        <div class="lead-form-field">
          <label>Approx Vehicle Count</label>
          <input type="number" [(ngModel)]="model.approx_vehicle_count" />
        </div>
        <div class="lead-form-field">
          <label>Existing System</label>
          <select [(ngModel)]="model.existing_system">
            <option *ngFor="let existingSystem of existingSystems" [value]="existingSystem[0]">
              {{ existingSystem[1] }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Sales Info</h4>
      <div class="lead-form-grid">
        <div class="lead-form-field">
          <label>Lead Source</label>
          <select [(ngModel)]="model.source">
            <option *ngFor="let source of sources" [value]="source[0]">{{ source[1] }}</option>
          </select>
        </div>
        <app-sales-installation-partner-select
          *ngIf="showPartnerField"
          [(value)]="model.sales_installation_partner">
        </app-sales-installation-partner-select>
        <div class="lead-form-field">
          <label>Assigned To</label>
          <select [(ngModel)]="model.assigned_to">
            <option value="">Unassigned</option>
            <option *ngFor="let assignee of assignees" [value]="assignee.id">
                {{ assigneeLabel(assignee) }}
            </option>
          </select>
        </div>
        <div class="lead-form-field">
          <label>Expected Closure Date</label>
          <p-datepicker
            [(ngModel)]="model.expected_closure_date"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            inputId="lead-expected-closure-date"
            [showOnFocus]="true"
            [showButtonBar]="true"
            [readonlyInput]="true">
          </p-datepicker>
        </div>
        <div class="lead-form-field">
          <label>Status</label>
          <select [(ngModel)]="model.status">
            <option *ngFor="let status of statuses" [value]="status[0]">{{ status[1] }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="lead-section">
      <h4>Notes</h4>
      <div class="lead-form-field">
        <label>Requirement Summary</label>
        <textarea [(ngModel)]="model.requirement_summary"></textarea>
      </div>
    </div>

    <div class="inline-actions">
      <button class="lead-btn" (click)="save()" [disabled]="saving || !model.customer_name || !model.phone_number">
        {{ saving ? 'Saving...' : (isEdit ? 'Update Lead' : 'Create Lead') }}
      </button>
      <button class="lead-btn-muted" (click)="router.navigate(['lead-management/leads'])">Cancel</button>
    </div>
  </div>
</div>
